import { AddProductToSavedBasket } from "../../../Services/BasketService"
import { useAuth } from "../../../Providers/AuthProvider"
import { toast } from "react-toastify"
import { useConfig } from "../../../Providers/ConfigProvider"

const useAddProductsToSavedBasket = () => {
    const { authState } = useAuth()

    const { api } = useConfig();

    const handleAddProductsToSavedBasket = async (basketId, products) => {
        try {
            var res = await AddProductToSavedBasket(api, basketId, products)
            toast.success('Dodano pozycje do szybkokoszyka')
            return true
        } catch (error) {
            toast.error('Błąd w trakcie dodawania pozycji do szybkokoszyka')
            return false
        }
    }

    return { handleAddProductsToSavedBasket }
}

export default useAddProductsToSavedBasket